export default __webpack_public_path__ + "static/media/instaclone.b3232699.png";